import masterCard from "../../../assets/images/Cards-icons/mastercard.svg";
import cirrus from "../../../assets/images/Cards-icons/cirrus.svg";
import maestro from "../../../assets/images/Cards-icons/maestro.svg";
import visaCard from "../../../assets/images/Cards-icons/visa.svg";
import visaPlus from "../../../assets/images/Cards-icons/visa-plus.svg";
import interlink from "../../../assets/images/Cards-icons/interlink.svg";
import discover from "../../../assets/images/Cards-icons/discover.svg";
import americanExpress from "../../../assets/images/Cards-icons/amex.svg";
import unionPay from "../../../assets/images/Cards-icons/unionpay.svg";
import blackhawak from "../../../assets/images/Cards-icons/blackhawak.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import { I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { toTitleCase } from "../../../Utils/stringUtls";
import {
  atm_networks as atmNetworksList,
  cardInfo,
  cardTechnology,
} from "../CardNetworkAndBinInfo/stringUtils";
import {
  binInformation,
  binType,
  cardOptions,
} from "../CardNetworkAndBinInfo/CardNetwork";
import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const CardNetworkAndBinInfo = ({ data }) => {
  if (!data) return <DataNotFound />;
  const {
    cn_n_networks,
    cn_atm_networks,
    cn_n_networks_other,
    cn_atm_networks_other,
    cn_bin_Information,
    cn_business_id,
    cn_bin_no,
    cn_settlement_currency,
    cn_bin_type,
    cn_bin_quantity,
    cn_bin_quantity_other,
    cn_target_date,
    cn_insurance_region,
    cn_additional_card_information,
    cn_additional_card_information_other,
    cn_chip_profile,
    cn_card_option,
    cn_card_number,
    cn_card_information,
    cn_card_information_other,
  } = data["3_0"];
  const networks = [
    {
      label: "Master Card ®",
      value: 0,
      icon: masterCard,
    },
    {
      label: "Cirrus ®",
      value: 1,
      icon: cirrus,
    },
    {
      label: "Maestro ®",
      value: 2,
      icon: maestro,
    },
    {
      label: "VISA ® Card",
      value: 3,
      icon: visaCard,
    },
    {
      label: "Interlink ® Card",
      value: 4,
      icon: visaPlus,
    },
    {
      label: "PLUS ® Card",
      value: 5,
      icon: interlink,
    },
    {
      label: "Discover ®",
      value: 6,
      icon: discover,
    },
    {
      label: "American Express ®",
      value: 7,
      icon: americanExpress,
    },
    {
      label: "UnionPay ®",
      value: 8,
      icon: unionPay,
    },
    {
      label: "Blackhawk Network ®",
      value: 9,
      icon: blackhawak,
    },
    {
      label: "Other",
      value: 10,
      icon: cardPlaceholder,
    },
  ];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">Card Networks</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {cn_n_networks?.length
              ? networks.map((network, index) =>
                  cn_n_networks?.includes(network.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <I2cIcon
                        src={network.icon}
                        style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                      />
                      <span>
                        {network.value === 10
                          ? toTitleCase(cn_n_networks_other)
                          : network.label}
                        ,
                      </span>
                      {/* {cn_n_networks?.length > index ? ", " : ""} */}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">ATM Networks</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {cn_atm_networks?.length
              ? atmNetworksList.map((network, index) =>
                  cn_atm_networks?.includes(network.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <I2cIcon
                        src={network.icon}
                        style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                      />
                      <span>
                        {network.value === 5
                          ? toTitleCase(cn_atm_networks_other)
                          : network.label}
                      </span>
                      {cn_atm_networks?.length > index ? ", " : ""}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">BIN Information</div>
          <div className="overview-help-text-for-heading review-summary-sub-heading font-bold">
            Do you have any specific BIN information?
          </div>
          <div className="overview-val-text">
            {binInformation[cn_bin_Information]?.label ?? "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Business ID</div>
          <div className="overview-val-text">
            {cn_business_id?.length ? toTitleCase(cn_business_id) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">BIN(s)</div>
          <div className="overview-val-text">
            {cn_bin_no?.length ? toTitleCase(cn_bin_no) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Settlement Currency
          </div>
          <div className="overview-val-text">
            {cn_settlement_currency?.length
              ? cn_settlement_currency.map((curr, index) => (
                  <span key={index}>
                    {curr +
                      (index === cn_settlement_currency?.length - 1
                        ? ""
                        : ", ")}
                  </span>
                ))
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Type of BIN</div>
          <div className="overview-val-text">
            {binType[cn_bin_type]?.label ?? "-"}
          </div>
        </div>
        <div i2c-grid="12">
          <div className="overview-help-text font-bold">
            Number of Sub-BIN(s)
          </div>
          <div className="overview-val-text">
            {cn_bin_quantity_other > 0
              ? cn_bin_quantity_other
              : cn_bin_quantity?.length
                ? cn_bin_quantity
                : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Target Install/Migration Date
          </div>
          <div className="overview-val-text">
            {cn_target_date?.length ? cn_target_date : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Issuance Country/Region(s)
          </div>
          <div className="overview-val-text">
            {cn_insurance_region?.length ? cn_insurance_region : "-"}
          </div>
        </div>

        <div i2c-grid="12">
          <div className="overview-help-text font-bold">Card Technology</div>
          <div className="overview-val-text">
            {cardTechnology.map((tech, index) => {
              if (
                cn_additional_card_information?.includes(tech.value) &&
                tech.value !== 4
              ) {
                return <span key={index}>{tech.label}, </span>;
              } else return "";
            })}
            {cn_additional_card_information_other?.length ? (
              <span key={cardTechnology.length + 1}>
                {cn_additional_card_information_other}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <div i2c-grid="12">
          <div className="overview-help-text font-bold">Chip Profile</div>
          <div className="overview-val-text">
            {cn_chip_profile?.length ? toTitleCase(cn_chip_profile) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Card Options</div>
          <div className="overview-val-text">
            {cn_card_option?.length
              ? cardOptions.find((opt) => opt.value === cn_card_option)?.label
              : "-"}
          </div>
        </div>
        {cn_card_number?.length ? (
          <div i2c-grid="6@md">
            <div className="overview-help-text font-bold">Card Number</div>
            <div className="overview-val-text">{cn_card_number}</div>
          </div>
        ) : (
          ""
        )}

        <div i2c-grid="12">
          <div className="overview-help-text font-bold">Card Information</div>
          <div className="overview-val-text">
            {cardInfo.map((tech, index) => {
              if (
                cn_card_information?.includes(tech.value) &&
                tech.value !== 4
              ) {
                return <span key={index}>{tech.label}, </span>;
              } else return "";
            })}
            {cn_card_information_other?.length ? (
              <span key={cardInfo.length + 1}>{cn_card_information_other}</span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardNetworkAndBinInfo;
